module.exports = __webpack_public_path__ + "img/full5-min.a10fb050.png";